import { render, staticRenderFns } from "./PublicBooking.vue?vue&type=template&id=6fb1b635&"
import script from "./PublicBooking.vue?vue&type=script&lang=js&"
export * from "./PublicBooking.vue?vue&type=script&lang=js&"
import style0 from "./PublicBooking.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports